import './app';
import './forecastBettingArea';
import './h2hBettingArea';
import './racecardBettingArea';
import './vmsUI';
import './vmsUiService';

export default 'terminalApp.sevenVirtualMotorcycleSpeedway';
